
export enum UnitNumberOfEmployees {
    UpTo10 = 1,
    Between10And50 = 2,
    Between50And100 = 3,
    Between100And500 = 4,
    Over500 = 5
}

export namespace UnitNumberOfEmployees {
    export function toString(val: UnitNumberOfEmployees): string {
        switch (val) {
            case UnitNumberOfEmployees.UpTo10:
                return '0 - 10';
            case UnitNumberOfEmployees.Between10And50:
                return '10 - 50';
            case UnitNumberOfEmployees.Between50And100:
                return '50 - 100';
            case UnitNumberOfEmployees.Between100And500:
                return '100 - 500';
            case UnitNumberOfEmployees.Over500:
                return '500+';
            default:
                return '';
        }
    }

    export function listAll(): UnitNumberOfEmployees[]{
        return [
            UnitNumberOfEmployees.UpTo10,
            UnitNumberOfEmployees.Between10And50,
            UnitNumberOfEmployees.Between50And100,
            UnitNumberOfEmployees.Between100And500,
            UnitNumberOfEmployees.Over500
        ]
    }

    export function parse(str:string) :UnitNumberOfEmployees{
        return UnitNumberOfEmployees[str];
    }
}

// export default UnitNumberOfEmployees;